import * as yup from "yup";

export const NurseFormSchema = yup.object({
  nurses_first_name: yup
    .string()
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be at most 50 characters")
    .required("First name is required"),
  nurses_last_name: yup
    .string()
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name must be at most 50 characters")
    .required("Last name is required"),
  nurses_national_id: yup
    .string()
    .min(13, "National ID must be at least 13 characters")
    .max(13, "National ID must be at most 13 characters")
    .required("National ID is required"),
  nurses_sex: yup.string().required("Sex is required"),
  nurses_dob: yup.string().required("Date of birth is required"),
  facility_name: yup
    .string()
    .min(2, "Facility name must be at least 2 characters")
    .max(100, "Facility name must be at most 100 characters")
    .required("Facility name is required"),
  facility_type: yup.string().required("Facility type is required"),
  facility_code: yup
  .string()
  .min(5, "Facility Code must be 5 characters")
  .max(5, "Facility Code must be 5 characters")
  .required("Facility Code is required"),
  city: yup
    .string()
    .min(2, "City must be at least 2 characters")
    .max(50, "City must be at most 50 characters")
    .required("City is required"),
  nurses_role: yup
    .string()
    .min(2, "Nurse role must be at least 2 characters")
    .max(50, "Nurse role must be at most 50 characters")
    .required("Nurse role is required"),
  nurses_email_id: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .max(50, "Password must be at most 50 characters")
    .required("Password is required"),
  nurses_contact: yup
    .string()
    .min(8, "Contact must be at least 8 digits")
    .max(8, "Contact must be at most 8 digits")
    .required("Contact is required"),
  nurses_region: yup
    .string()
    .min(2, "Region must be at least 2 characters")
    .max(50, "Region must be at most 50 characters")
    .required("Region is required"),
    section: yup.string()
    .required("Section is required"),
    confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required'),
});


export const updateNurseFormSchema = yup.object({
  nurses_first_name: yup
    .string()
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be at most 50 characters")
    .required("First name is required"),
  nurses_last_name: yup
    .string()
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name must be at most 50 characters")
    .required("Last name is required"),
  nurses_national_id: yup
    .string()
    .min(13, "National ID must be at least 13 characters")
    .max(13, "National ID must be at most 13 characters")
    .required("National ID is required"),
  nurses_sex: yup.string().required("Sex is required"),
  nurses_dob: yup.string().required("Date of birth is required"),
  facility_name: yup
    .string()
    .min(2, "Facility name must be at least 2 characters")
    .max(100, "Facility name must be at most 100 characters")
    .required("Facility name is required"),
  facility_type: yup.string().required("Facility type is required"),
  city: yup
    .string()
    .min(2, "City must be at least 2 characters")
    .max(50, "City must be at most 50 characters")
    .required("City is required"),
  nurses_role: yup
    .string()
    .min(2, "Nurse role must be at least 2 characters")
    .max(50, "Nurse role must be at most 50 characters")
    .required("Nurse role is required"),
  nurses_email_id: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  password: yup
    .string()
    .optional(""),
  nurses_contact: yup
    .string()
    .min(8, "Contact must be at least 8 digits")
    .max(8, "Contact must be at most 8 digits")
    .required("Contact is required"),
  nurses_region: yup
    .string()
    .min(2, "Region must be at least 2 characters")
    .max(50, "Region must be at most 50 characters")
    .required("Region is required"),
    section: yup.string()
    .required("Section is required"),
    confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Password confirmation is required')
});
